var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrievanceRedressalBottomLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 4,
    viewBox: "0 0 473 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.556624 1.75L2 3.19338L3.44338 1.75L2 0.306624L0.556624 1.75ZM472.443 1.75004L471 0.306665L469.557 1.75004L471 3.19342L472.443 1.75004ZM2 2L471 2.00004L471 1.50004L2 1.5L2 2Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrievanceRedressalBottomLine);
export default __webpack_public_path__ + "static/media/grievance-redressal-bottom-line.e3df3b93fcba0ebf02b4dc1110a48ed8.svg";
export { ForwardRef as ReactComponent };